export const prescriptionType = [
    {
        key: 'Select a Filter',
        value: '', 
    },
    {
        key: 'Active',
        value: 'active',
    },
    {
        key: 'Discontinued',
        value: 'discontinued',
    },
    {
        key: 'Unverified',
        value: 'unverified',
    }
];